// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2_z8I","legacyBtn":"MutateMid_legacyBtn__3fdmW"};